import { capitalize } from '@/js/base/filters'
import { dateFormat } from '@/js/base/dateformat'
import store from '@/store'
import axios from 'axios'
import {clearCache} from "clear-cache"


export function Field (name, params = {}) {
  let label
  let join = null
  if (name.endsWith('_id')) {
    join = true
    label = capitalize(name.substr(0, name.length - 3))
  } else {
    label = capitalize(name)
  }

  let f = {
    value: name,
    text: label,
    html: null,
    template: false,
    appendTemplate: false,
    component: null, // { value: 'v-icon', class: '', color: '', style: '', text: function () {}, click: function () {} }
    type: 'int',
    before: null,
    after: null,
    align: 'left', // right center
    length: 0,
    sortable: true,
    required: false,
    default: '',
    calculate: null,
    seconds: true,
    // os itens de btn devem ser registrados na definicao do campo, senao nao serao reativos
    // btn.loading e btn.hide deve ser um [] (array), incluir o item a ser oculto ou loading
    btn: null, // { caption style color class icon iconized link small xSmall hide disabled depressed fab outlined rounded text tile loading items}
    hint: '',
    gridable: true, 
    editable: true, // editable=false - não executa rules
    readonly: false,
    noSave: false,
    disable: false,
    visible: true, // visible=false - executa rules (display:none)
    error: '',
    mask: null,
    rules: [],
    rulesAlways: false,
    hidePwd: true,
    image: { width: 100, height: 100, quality: 0.85 },
    loading: false,
    items: null,
    counterItems: false,
    itemsDisabled: null,
    itemsRefresh: false,
    multiple: false,
    combobox: false,
    join: join, // nome tabela relacionada ou true para retirar do nome do campo (municipio_id)
    // join: function (val, vm) => return [fieldname, args]
    link: null,
    class: 'xs6 sm4 md3 lg2 xl2',
    class2: '',
    // xs > 0px     sm >= 600px     md >= 960px     lg >= 1280px     xl >= 1920px
    // xs12 = 1col  sm4 = 3 cols    md3 = 4 cols    lg2 = 6 cols     xl1 = 12 cols
    decimal: 2,
    fixDecimal: true,
    nullIsNotZero: false,
    prefix: '',
    prefixJoin: '',  // campo de contem o prefix
    suffix: '',
    rows: 1,
    group: '',
    groupStyle: '',
    prependIcon: null,
    prependClick: () => {},
    prependInnerIcon: null,
    prependInnerClick: () => {},
    appendIcon: null,
    appendClick: null,
    appendOuterIcon: null,
    appendOuterClick: () => {}
  }

  fModifier(f, params)
  return f
}

export function fModifier (f, params) {
  for (let key in params)
    f[key] = params[key]

  if (f['rules'].length === 0 && f['value'] !== 'id' && !f['readonly']) {
    if (f['required'] && f['type'] !== 'bool') {
      if (f['type'] === 'int')
        f['rules'] = [(v) => (toInt(v) > 0) || 'Deve ser maior que zero']
      else if (f['type'] === 'float')
        f['rules'] = [(v) => (toFloat(v) > 0) || 'Deve ser maior zero']
      else if (f['type'] === 'date')
        f['rules'] = [isDate]
      else if (f['type'] === 'datetime')
        f['rules'] = [isDate]
      else
        f['rules'] = [(v) => !!v || 'Obrigatório um valor']
    } else if (f['type'] === 'int')
      f['rules'] = [(v) => (toInt(v) >= 0) || 'Obrigatório valor positivo']
    else if (f['type'] === 'float')
      f['rules'] = [(v) => (toFloat(v) >= 0) || 'Obrigatório valor positivo']
    else if (f['type'] === 'bool')
      f['rulesAlways'] = true
  }

  if (f['type'] === 'float') {
    f['align'] = 'right'
  }

  // if (f['type'] === 'bool' && f['readonly']) {
  //   // alert(f['value'] + ': não use READONLY em campo BOOLEAN, use DISABLE.')  // alert nao use
  //   f['readonly'] = false
  //   f['disable'] = true
  // }
}

export function isDate (val) {
  if (!val) return 'Obrigatório um valor'
  let day, month, year, aammdd, ok
  if (typeof(val) == 'object') {
    val = dateFormat(val, 'yyyy-mm-dd HH:MM:ss')
  }
  if (val.indexOf('-') >= 0) {
    [year, month, day] = val.split('-')
    day = day.split(' ')[0]
  } else {
    [day, month, year] = val.split('/')
    year = year.split(' ')[0]
  }
  if (day === undefined || year === undefined || year.length < 4) {
    ok = 'Invalid Date'
  } else {
    aammdd = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    ok = new Date(aammdd)
  }
  if (ok.toString() === 'Invalid Date') return 'Data inválida'
  return true 
}

export function dmyYmd (val) {
  if (!val) return val
  let day, month, year, aammdd, ok
  if (typeof(val) == 'object') {
    val = dateFormat(val, 'yyyy-mm-dd HH:MM:ss')
  }
  if (val.indexOf('-') >= 0) {
    [year, month, day] = val.split('-')
    day = day.split(' ')[0]
  } else {
    [day, month, year] = val.split('/')
    year = year.split(' ')[0]
  }
  if (day === undefined || year === undefined || year.length < 4) {
    return val
  }
  aammdd = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
  ok = new Date(aammdd)
  if (ok.toString() === 'Invalid Date') {
    return val
  }
  return aammdd
}

export function deepCopy (obj, ignore = []) {
  let output, value, key
  output = Array.isArray(obj) ? [] : {}
  for (key in obj) {
    if (ignore.indexOf(key) < 0) {
      value = obj[key]
      output[key] = (value === null) ? null : ((typeof value === 'object') ? deepCopy(value) : value)
    }
  }
  return output
}

export function hasGrant (link) {
  let icon = ''
  if (link) {
    let groups = store.state.routes[link]
    if (groups) {
      var mygroups = store.state.groups
      for (var i = 0; i < groups.length; i++) {
        if (mygroups.indexOf(groups[i]) >= 0) {
          icon = 'mdi-link'
          break
        }
      }
    }
  }
  return icon
}

export function hasGroup (group) {
  let groups = store.state.groups
  let result = groups.indexOf(group)
  return result >= 0
}

export function toLink (event, router, link, search = '') {
  store.commit('JOIN_LINK', link)
  let url = link.split('?')[0]
  if (hasGrant(url)) {
    if (event && event.ctrlKey) {
      setCookie('Authorization', store.state.token)
      setCookie('Instance', store.state.instance)
      setCookie('clientVersion', store.state.clientVersion)
      let route = router.resolve(link + search)
      window.open(route.href, '_blank')
    } else {
      // document.body.setAttribute('style', 'cursor: wait;')
      router.push(link + search)
    }
  } else {
    console.log('Usuário não tem permissão de acesso ao endereço: ' + link)
  }
}

export function toBlank (router, link, args) {
  // let url = store.state.serverURI + link + '?Authorization=' + store.state.token + '&Instance=' +  store.state.instance
  setCookie('Authorization', store.state.token)
  setCookie('Instance', store.state.instance)
  setCookie('clientVersion', store.state.clientVersion)
  let url = store.state.serverURI + link + '?referer=' + window.location.pathname
  for (let arg in args) {
    url += '&' + arg + '=' + args[arg]
  }
  // let route = router.resolve(url)
  window.open(url, '_blank')
}

export function powerPassword (password) {
  // >5=forte 4=média 3=fraca 2,1=muito fraca
  let ponts = 0
  if (password.length >= 8) {
    ponts += 1
    for (let i = 0; i < password.length; i++) {
      if ('!£$%^&*_@#~?'.indexOf(password.charAt(i)) > -1) {
        ponts += 1
        break
      }
    }
    if (/\d/.test(password)) ponts += 1 // numeros
    if (/[a-z]/.test(password)) ponts += 1 // letras minúsculas
    if (/[A-Z]/.test(password)) ponts += 1 // letras maiúsculas
  }
  return ponts
}

export function resizeImg (imgCurrent, width, height, proc, params) {
  let imgResize = new Image()
  imgResize.onload = function () {
    let canvas = document.createElement('canvas')
    let ctx = canvas.getContext('2d')
    if (imgResize.naturalWidth > width || imgResize.naturalHeight > height) {
      let scale = Math.min((width / imgResize.width), (height / imgResize.height))
      let wScaled = imgResize.width * scale
      let hScaled = imgResize.height * scale
      canvas.width = wScaled
      canvas.height = hScaled
      ctx.drawImage(imgResize, 0, 0, wScaled, hScaled)
      proc(params, canvas.toDataURL('image/png', 0.5))
    }
  }
  imgResize.src = imgCurrent
}

export function getPngDimensions (base64) {
  base64 = base64.split(',')[1]
  const header = atob(base64.slice(0, 50)).slice(16, 24)
  const uint8 = Uint8Array.from(header, c => c.charCodeAt(0))
  const dataView = new DataView(uint8.buffer)

  return {
    width: dataView.getInt32(0),
    height: dataView.getInt32(4)
  }
  // Just to get some base64 png example
  // const canvas = document.createElement('canvas')
  // const base64 = canvas.toDataURL().split(',')[1]

  // const dimensions = getPngDimensions(base64)
  // console.log(dimensions)
}

export function toInt (val) {
  return parseInt(val) || 0
}

export function toFloat (val) {
  if (typeof (val) === 'string') {
    if (val.indexOf(',') >= 0)
      val = val.replace(/\./g, '').replace(/,/g, '.').replace(/[^0-9.-]/g, '')
  }
  return parseFloat(val) || 0
}

export function toFixed (val, dec = 2) {
  let valF = parseFloat(val)
  return valF.toFixed(dec)
}


export function maxAdd (value1, value2, value3) {
  value1 = toFloat(value1)
  value2 = toFloat(value2)
  value3 = toFloat(value3)
  if (value1 < 0) value1 = 0
  if (value1 < 0) value1 = 0
  if (value1 < 0) value1 = 0
  return ((value1 > value2) ? value1 : value2) + value3
}


export function now () {
  let today = new Date()
  return dateFormat(today, 'yyyy-mm-dd HH:MM:ss')
}

export function today (hour=false, secs=false) {
  let t = new Date()
  if (hour) {
    if (secs)
      return dateFormat(t, 'HH:MM:ss')
    else
      return dateFormat(t, 'HH:MM')
  } else
    return dateFormat(t, 'yyyy-mm-dd')
}

export function dayWeek (date1) {
  let sem = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"]
  let date2 = new Date(date1)
  return sem[date2.getDay()]
}

export function strToDate(date1) {
  if (typeof (date1) === 'string') {
    date1 = date1.split(' ')[0]
    let [year, month, day] = date1.split('-')
    if (day === undefined) {
      [day, month, year] = date1.split('/')
    }
    if (!year) {
      let t = new Date()
      year = t.getYear() + 1900
    } else {
      year = parseInt(year)
    }
    if (year < 100) {
      year = year + 100
    }
    date1 = new Date(`${month}/${day}/${year}`)
  }
  return date1
}

export function dateToStr (date1) {
  let date2 = dateAdd(date1, 1)
  return dateFormat(date2, 'dd/mm/yyyy')
}

function newdate () {
  let today = new Date()
  today.setHours(0)
  today.setMinutes(0)
  today.setSeconds(0)
  today.setMilliseconds(0)
  return today
}

export function dateAdd (today, days) {
  const ONE_DAY = 1000 * 60 * 60 * 24
  if (today === null) 
    today = new Date()
  today = strToDate(today)
  today = new Date(today.getTime() + (toInt(days) * ONE_DAY))
  return dateFormat(today, 'yyyy-mm-dd')
}

export function dateDiff(date1, date2=null) {
  // Se date1 menor que date2 retorna valor negativo
  // date1 = date1 ? strToDate(date1) : newdate()
  if (date1) {
    date1 = strToDate(date1)
   } else {
    date1 = newdate()
   }
  date2 = date2 ? strToDate(date2) : newdate()
  let date1_ms = date1.getTime()
  let date2_ms = date2.getTime()
  const ONE_DAY = 1000 * 60 * 60 * 24
  return parseInt((date1_ms - date2_ms) / ONE_DAY)
}

export function minutesDiff(date1, date2=null) { 
  // Sempre retorna valor positivo
  if (typeof(date1) === 'string')
    date1 = new Date(date1)
  if (!date2)
    date2 = new Date()
  else if (typeof(date2) === 'string')
    date2 = new Date(date2)
  const ONE_MINUTE = 1000 * 60
  return parseInt(Math.abs((date1.getTime() - date2.getTime()) / ONE_MINUTE))
}

export function toDate (date1) {
  if (!date1)
    date1 = new Date()
  return strToDate(date1).getTime()
}

export function checked (values, value) {
  values = '|' + (values || '') + '|'
  value = '|' + (value || '') + '|'
  return values.indexOf(value) >= 0
}

export function splitExtra (value, pos = null) {
  let result
  if (typeof (value) === 'object') result = value
  else result = (value || '').split('^&')
  if (pos === null) return result
  else return result[pos]
}

export function merge (arr1, arr2, del = false) {
  if (del)
    arr1.splice(0, arr1.length)
  for (let val of arr2)
    arr1.push(val)
}

export function calcImpostos (data, valor) {
  let icmsStBc = 0
  let icmsStValor = 0
  let fcpBc = 0
  let fcpValor = 0
  let fcpStBc = 0
  let fcpStValor = 0
  let aliqInterna = toFloat(data.aliqInterna)
  let aliqDifer = toFloat(data.aliqDifer)
  let aliqExterna = toFloat(data.aliqExterna)
  let aliqFcp = toFloat(data.fcp)
  let aliqFcpSt = toFloat(data.fcpSt)
  let aliqIpi = toFloat(data.ipiAliq)
  let mva = toFloat(data.mva)
  let icmsStAliq = toFloat(data.icmsStAliq)
  let temSt = data.icmsSt !== '0' && mva > 0
  let ipiBc = 0
  let ipiValor = 0
  let erro = ''

  if (aliqIpi > 0) {
    ipiBc = valor
    ipiValor = valor * (aliqIpi / 100)
  }

  if (!data.consumFinal && !data.contribuinte) {
    erro = 'Erro de cadastro. Revenda deve ser contribuinte ICMS!'
  } else {  // if (data.simplesNac) {
    let bcIcms = valor
    if (data.consumFinal && !data.industria) {
      bcIcms += ipiValor
    }

    if (aliqFcp > 0) {
      fcpBc = bcIcms
      fcpValor = bcIcms * (aliqFcp / 100)
    }

    // venda dentro do Estado
    if (data.opEstadual) {
      if (temSt && !data.consumFinal && data.icmsSt === '1') { // icmsSt=2 (st cobrada anteriormente)
        icmsStBc = valor * (1 + (mva / 100))
        icmsStValor = (icmsStBc * aliqInterna / 100) -
                      (valor * aliqInterna / 100 * ((100 - aliqDifer) / 100))

        if (aliqFcpSt > 0) {
          fcpStBc = icmsStBc
          fcpStValor = icmsStBc * (aliqFcpSt / 100)
        }
      }
    // venda para outro Estado
    } else if (data.contribuinte) {
      if (temSt) {
        let icmsA = valor * aliqExterna / 100
        if (data.consumFinal)
          icmsStBc = valor
        else if (data.zonaFranca)
          icmsStBc = (valor - icmsA) * (1 + (mva / 100))
        else
          icmsStBc = valor * (1 + (mva / 100))
        icmsStValor = icmsStBc * (aliqInterna / 100) - icmsA

        if (aliqFcpSt > 0) {
          fcpStBc = icmsStBc;
          fcpStValor = icmsStBc * (aliqFcpSt / 100);
        }
      }
    } else if (data.consumFinal) {
      // o valor da DIFAL não integra o total da nota
      // incluir somente no xml e nas informacoes complementares
      // contudo GNRE deve ser recolhida
      // liminar 5464 ADI STF suspendeu cobranca da DIFAL
      // para emitente SN e destinatario consumidor final
    }
  }

  return {
    icmsStBc: icmsStBc,
    icmsStValor: icmsStValor,
    icmsStMva: mva,
    icmsStAliq: icmsStAliq,
    fcpBc: fcpBc,
    fcpValor: fcpValor,
    fcpStBc: fcpStBc,
    fcpStValor: fcpStValor,
    ipiBc: ipiBc,
    ipiValor: ipiValor,
    ipiAliq: data.ipiAliq,
    erro: erro
  }
}

export function mascaraCpfCnpj (value) {
  if (value) {
    value = value.replace(/\D/g,"")
    if (value.length >= 4 && value.length <= 6)
      value = value.replace(/^(\d{3})/g,"$1.")
    else if (value.length <= 9)
      value = value.replace(/^(\d{3})(\d{3})/g,"$1.$2.")
    else if (value.length <= 11)
      value = value.replace(/^(\d{3})(\d{3})(\d{3})/g,"$1.$2.$3-")
    else if (value.length == 12)
      value = value.replace(/^(\d{2})(\d{3})(\d{3})/g,"$1.$2.$3/")
    else
      value = value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})/g,"$1.$2.$3/$4-")
  }
  return value
}

export function mascaraCpf (value) {
  if (value) {
    value = value.replace(/\D/g,"")
    if (value.length >= 4 && value.length <= 6)
      value = value.replace(/^(\d{3})/g,"$1.")
    else if (value.length <= 9)
      value = value.replace(/^(\d{3})(\d{3})/g,"$1.$2.")
    else if (value.length <= 11)
      value = value.replace(/^(\d{3})(\d{3})(\d{3})/g,"$1.$2.$3-")
  }
  return value
}

export function mascaraCnpj (value) {
  if (value) {
    value = value.replace(/\D/g,"")
    if (value.length >= 3 && value.length <= 5)
      value = value.replace(/^(\d{2})/g,"$1.")
    else if (value.length <= 8)
      value = value.replace(/^(\d{2})(\d{3})/g,"$1.$2.")
    else if (value.length <= 12)
      value = value.replace(/^(\d{2})(\d{3})(\d{3})/g,"$1.$2.$3/")
    else
      value = value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})/g,"$1.$2.$3/$4-")
  }
  return value
}

export function mascaraTel (value) {
  if (value) {
    value = value.replace(/\D/g,"")                  //Remove tudo o que nao e digito
    value = value.replace(/^(\d{2})(\d)/g,"($1) $2") //Coloca paranteses em volta dos dois primeiros digitos
    value = value.replace(/(\d)(\d{4})$/,"$1-$2")    //Coloca hifen entre o quarto e o quinto digitos
  }
  return value
}

export function mascaraCep (value) {
  if (value) {
    value = value.replace(/\D/g,"")                //Remove tudo o que nao e digito
    value = value.replace(/^(\d{5})(\d)/g,"$1-$2") //Coloca hifen entre o quarto e o quinto digitos
  }
  return value
}

export function mascaraPlaca (value) {
  if (value) {
    value = value.replace(/ /g,"").toUpperCase()
    value = value.replace(/\d/g,"").substr(0,3)
    if (value.length > 3)
      value += value.replace(/\D/g,"").substr(0,4)
  }
  return value
}

export function isCpf (cpf) {
  cpf = cpf ? cpf.replace(/\D/g,"") : ''
  if (!cpf || cpf.length != 11
    || cpf == "00000000000"
    || cpf == "11111111111"
    || cpf == "22222222222" 
    || cpf == "33333333333" 
    || cpf == "44444444444" 
    || cpf == "55555555555" 
    || cpf == "66666666666"
    || cpf == "77777777777"
    || cpf == "88888888888" 
    || cpf == "99999999999")
  return false

  let soma = 0
  let resto
  for (let i = 1; i <= 9; i++) 
    soma = soma + parseInt(cpf.substring(i-1, i)) * (11 - i)
  resto = (soma * 10) % 11
  if ((resto == 10) || (resto == 11))
    resto = 0
  if (resto != parseInt(cpf.substring(9, 10)) )
    return false
  soma = 0
  for (let i = 1; i <= 10; i++)
    soma = soma + parseInt(cpf.substring(i-1, i)) * (12 - i)
  resto = (soma * 10) % 11
  if ((resto == 10) || (resto == 11))
    resto = 0
  if (resto != parseInt(cpf.substring(10, 11) ))
    return false
  return true
  }

export function isCnpj (cnpj) {
  cnpj = cnpj ? cnpj.replace(/\D/g,"") : ''
  if (!cnpj || cnpj.length != 14
      || cnpj == "00000000000000" 
      || cnpj == "11111111111111" 
      || cnpj == "22222222222222" 
      || cnpj == "33333333333333" 
      || cnpj == "44444444444444" 
      || cnpj == "55555555555555" 
      || cnpj == "66666666666666" 
      || cnpj == "77777777777777" 
      || cnpj == "88888888888888" 
      || cnpj == "99999999999999")
    return false
  let tamanho = cnpj.length - 2
  let numeros = cnpj.substring(0,tamanho)
  let digitos = cnpj.substring(tamanho)
  let soma = 0
  let pos = tamanho - 7
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2)
      pos = 9
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
  if (resultado != digitos.charAt(0))
    return false;
  tamanho = tamanho + 1
  numeros = cnpj.substring(0,tamanho)
  soma = 0
  pos = tamanho - 7
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2)
      pos = 9
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
  if (resultado != digitos.charAt(1))
    return false
  return true;
}

export function isCpfCnpj (value) {
  return isCpf(value) || isCnpj(value)
}


export function findValue (values, value) {
  for (let item of values) {
    if (item.value == value)
      return item.text
  }
  return ''
}


export function foundValue (values, value) {
  for (let item of values) {
    if (item.value == value)
      return true
  }
  return false
}

export function disableAutoComplete () {
  let elements = document.querySelectorAll('[autocomplete="off"]');
  if (!elements) {
    return;
  }
  elements.forEach(element => {
    element.setAttribute('readonly', 'readonly');
    element.style.backgroundColor = 'inherit';
    window.addEventListener('load', () => {
      setTimeout(() => {
        element.removeAttribute('readonly');
      }, 500);
    });
  });
}

export function setCookie (cname, cvalue, seconds=30) {
  var d = new Date()
  d.setTime(d.getTime() + (seconds*1000))   // *24*60*60
  var expires = 'expires=' + d.toGMTString() 
  document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/;'
}

export function getCookie (cname) {
  var name = cname + "="
  var ca = document.cookie.split(';')
  for(var i=0; i<ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0)==' ') 
      c = c.substring(1)
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export function isMobile() {
  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone|Opera Mini/i.test(navigator.userAgent)) {
    return true
  } else {
    return false
  }
}


// function copied from http://detectmobilebrowsers.com/
export function isMobileOrTablet() {
  let check = false
  if (navigator.userAgentData != undefined && navigator.userAgentData.mobile) {
    check = true
  } else {
    let w = screen.width
    let h = screen.height
    if (h > w) {
      let t = h
      h = w
      w = t
    }
    if (w < 640 || h < 480) {
      check = true  //  smartphone
    } else if (w < 1024 || h < 768) {
      check = true  // tablet
    }
  }
  return check;
}

/*
export function isMobileOrTablet() {
  var check = false;
  // eslint-disable-next-line
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}
//window.isMobileOrTablet = window.isMobileOrTablet || isMobileOrTablet;
*/


export function openFullscreen() {
  try {
    if (!isFullscreen()) {
      let elem = document.documentElement
      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.webkitRequestFullscreen) { // Safari
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) { // IE11
        elem.msRequestFullscreen()
      }
    }
  } catch (e) {
    return null
  }
}

export function closeFullscreen() {
  try {
    if (isFullscreen()) {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.webkitExitFullscreen) { // Safari
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) { // IE11
        document.msExitFullscreen()
      }
    }
  } catch (e) {
    return null
  }
}

export function isFullscreen() {
  try {
    return document.isFullscreen || document.webkitIsFullScreen || document.msisFullscreen
  } catch (e) {
    return false
  }
}

/*
export function beep() {
  let snd = new Audio("data:audio/wav;base64,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")
  snd.play()
}
*/

export function beepAC (vol, freq, duration) {
  let ac = new AudioContext()
  let v = ac.createOscillator()
  let u = ac.createGain()
  v.connect(u)
  v.frequency.value = freq
  v.type = "square"
  u.connect(ac.destination)
  u.gain.value = vol*0.01
  v.start(ac.currentTime)
  v.stop(ac.currentTime+duration*0.001)
}

export function beep() {
  beepAC(100, 520, 200)
}

export function beepErr() {
  beepAC(100, 220, 300)
}

export function beepAlert() {
  beepAC(100, 210, 800)
  beepAC(100, 500, 800)
}

export function leftPad (value, length, paddingChar='0') {
  return String(value).padStart(length, paddingChar)
}

export function replaceAll (text, search, to) {
  const re = new RegExp(search, 'g')
  return (text || '').replace(re, to)
}

export function onlyNumbers(text)
{
  return (text || '').replace(/\D/g, '')
}

// compare versao e limpa cache se necessario
export function verifyClearCache() {
  let cacheCleared = localStorage.getItem('cacheCleared')
  if ((!cacheCleared) || (minutesDiff(cacheCleared, now(), false) > 1)) {
    localStorage.setItem('cacheCleared', now())
    axios.get(store.state.serverURI+'compareversion.php?clientVersion='+store.state.clientVersion).then(
      function (response) {
        if (response.data === 'clear-cache') {
          clearCache()
        }
      }
    )
  }
}

export function validGTIN(value) {
  let result = true
  value = String(value || '').replace(/\D/g,"")
  let l = value.length
  if (l <= 0 || [8,12,13,14].indexOf(l) == -1) {
    result = 'Valor deve ter 8, 12, 13 ou 14 caracteres'
  } else {
    let sum = 0
    let mult = 3
    for (let i = l-2; i >= 0; i--) {
      sum += parseInt(value[i]) * mult
      mult = mult === 3 ? 1 : 3
    }
    let digit = 10 - (sum % 10)
    if (digit == 10) {
      digit = 0
    }
    if (digit != parseInt(value[l-1])) {
      result = 'Dígito verificador inválido'
    }
  }
  return result
}

export function compareArrays (a, b) {
  if (a.length !== b.length) {
    return false;
  }
  else {
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) {
        return false;
      }
    }
    return true;
  }
}
